import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import styles from '../styles/MenuShowcase.module.css';

const MenuShowcase = ({ featured, columns }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const { t } = useI18n();

  return (
    <section className={styles.section} aria-labelledby="showcase-title">
      <header className={styles.heading}>
        <h2 id="showcase-title">{t('pages.menu.showcaseTitle')}</h2>
        <p>{t('pages.menu.showcaseText')}</p>
      </header>

      <div className={styles.featured}>
        {featured.map(item => (
          <Link className={styles.featureCard} key={item.id} to={item.to}>
            <img
              src={item.image}
              alt={item.alt || t(item.titleKey)}
              loading="lazy"
              decoding="async"
            />
            <span className={styles.featureShade} aria-hidden="true" />
            <span className={styles.featureCopy}>
              <strong>{t(item.titleKey || item.title)}</strong>
              <span>{t(item.subtitleKey || item.subtitle)}</span>
            </span>
          </Link>
        ))}
      </div>

      <div className={styles.columns}>
        {columns.map(column => (
          <div className={styles.column} key={column.id}>
            <h3>{t(column.titleKey || column.title)}</h3>
            <div className={styles.rule} aria-hidden="true" />
            <div className={styles.items}>
              {column.items.map(item => (
                <article className={styles.item} key={item.id}>
                  <button
                    className={styles.itemImage}
                    type="button"
                    onClick={() => setSelectedItem(item)}
                    aria-label={`${t('pages.menu.openDetails')} ${t(item.nameKey || item.name)}`}
                  >
                    <img src={item.image} alt="" loading="lazy" />
                  </button>
                  <div className={styles.itemCopy}>
                    <h4>{t(item.nameKey || item.name)}</h4>
                    <p>{t(item.ingredientsKey || item.ingredients)}</p>
                  </div>
                  <span className={styles.price}>{item.price}</span>
                </article>
              ))}
            </div>
          </div>
        ))}
      </div>

      {selectedItem && (
        <div
          className={styles.modalLayer}
          role="presentation"
          onMouseDown={event => {
            if (event.target === event.currentTarget) setSelectedItem(null);
          }}
        >
          <div className={styles.modal} role="dialog" aria-modal="true" aria-labelledby="showcase-item-title">
            <button
              className={styles.modalClose}
              type="button"
              onClick={() => setSelectedItem(null)}
              aria-label={t('pages.menu.close')}
            >
              ×
            </button>
            <img
              className={styles.modalImage}
              src={selectedItem.image}
              alt={t(selectedItem.nameKey || selectedItem.name)}
              decoding="async"
            />
            <div className={styles.modalCopy}>
              <p className={styles.modalLabel}>{t('pages.menu.menuItem')}</p>
              <h2 id="showcase-item-title">{t(selectedItem.nameKey || selectedItem.name)}</h2>
              <p>{t(selectedItem.ingredientsKey || selectedItem.ingredients)}</p>
              <strong className={styles.modalPrice}>{selectedItem.price}</strong>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

MenuShowcase.defaultProps = {
  featured: [],
  columns: [],
};

export default MenuShowcase;
